import { EmailTemplate, Language } from "@types";
import { Button, Modal, Space } from "antd";
import { Pencil } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EmailTemplateForm } from "@components";

interface Props {
  emailTemplate: EmailTemplate;
  languages: Language[];
}

export const EmailTemplatesTableActions = ({ emailTemplate, languages }: Props) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Space>
      <Button id={`edit-${emailTemplate.name}-${emailTemplate.languageId}`} onClick={() => setIsModalOpen(true)} icon={<Pencil />} />

      <Modal
        title={t("emailTemplateEditor.edit")}
        onCancel={() => setIsModalOpen(false)}
        open={isModalOpen}
        footer={null}
        destroyOnClose
        width={1500}
        styles={{ body: { paddingTop: 12 } }}
      >
        <EmailTemplateForm emailTemplate={emailTemplate} languages={languages} setIsModalOpen={setIsModalOpen} />
      </Modal>
    </Space>
  );
};